import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const PageWrapper = styled.div`
	background-color: #fff;
	width: 100%;
	height: 100%;
	display: inline-block;

	${media.greaterThan(breakpoints.ipad)`
    	color: white;
  	`}
`;
